<template>
    <div class=" w-72 ml-6 mr-3">
        <h3 class="text-sm font-bold text-grey-light hover:text-grey-dark mt-3 mb-1 flex ">
                <NavLink :to="categoryTools.buildCategorySlug(category)" class="w-57 pr-2">{{category.title.nl}}</NavLink>
        </h3>
        <ul>
            <li class="pb-1 text-grey-light hover:text-grey-dark flex " 
                v-for="subcategory in subcategories" 
                :key="subcategory.id">
                <NavLink :to="categoryTools.buildCategorySlug(subcategory)" class="w-57 pr-2">{{subcategory.title.nl}}</NavLink>
                <StudiewijzerIcons :studiewijzer="subcategory.studiewijzers" class="flex justify-end w-15" megamenu />
            </li>

        </ul>
    </div> 
</template>

<script setup>
    const categoryStore = useCategoryStore();
    const categoryTools = useCategoryTools();

    const props = defineProps({
        category: {
            required: true,
            type: Object,
        }
    });

    const subcategories = computed(() => categoryTools.publicCategoriesSorted(categoryStore.categoriesByParentId(props.category.id)))
</script>
